import { MEMBER_ROLE_OPTIONS } from '../members/memberConstants';
import {
  defaultUserStatsDateRange,
  formatReportAmount,
  formatReportCount,
  validateUserStatsDateRange,
} from './userStatisticsReportConstants';

export const AGENT_STATS_PAGE_SIZE = 20;

export const AGENT_STATS_ROLE_OPTIONS = MEMBER_ROLE_OPTIONS;

export { defaultUserStatsDateRange, formatReportAmount, formatReportCount, validateUserStatsDateRange };

export function buildAgentStatsPageParams(pageNo, filters = {}, pageSize = AGENT_STATS_PAGE_SIZE) {
  const params = {
    pageNo,
    pageSize,
  };
  if (filters.roleId) {
    params.roleId = Number(filters.roleId);
  }
  if (filters.startDateInput) {
    params.start = filters.startDateInput;
  }
  if (filters.endDateInput) {
    params.end = filters.endDateInput;
  }
  if (filters.agentId?.trim()) {
    params.agentId = filters.agentId.trim();
  }
  if (filters.agentUsername?.trim()) {
    params.agentUsername = filters.agentUsername.trim();
  }
  return params;
}

export function buildAgentStatsExportParams(filters = {}, exportCurrentPageOnly, pageNo) {
  const params = buildAgentStatsPageParams(pageNo || 1, filters, AGENT_STATS_PAGE_SIZE);
  params.exportCurrentPageOnly = exportCurrentPageOnly;
  params.fileName = 'agent_daily_report';
  return params;
}
